module.exports = __webpack_public_path__ + "img/trainLogo.d0bc04ad.png";